import { css } from "styled-components";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
const veciToggleStyles = {
    ToggleWrapper: ()=>css`
		--toggle-background-color-before: ${({ theme  })=>theme.colors.primary.light};
		--toggle-background-color-after: ${({ theme  })=>theme.colors.grays.light};
		--toggle-color-before: ${({ theme  })=>theme.colors.white.base};
		--toggle-color-after: ${({ theme  })=>theme.colors.text.dark};
	`,
    InputInner: ()=>css`
		::before,
		::after {
			${FontMixin({
            size: 'medium'
        })};
		}
	`
};
export default veciToggleStyles;

//# sourceMappingURL=veci.js.map